import React from "react";
import countries from "src/assets/locales/countries";
import { useTranslation } from "react-i18next";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const CountryField = ({ value, setValue, error }) => {
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    // eslint-disable-next-line no-unused-vars
    const { t } = useTranslation();

    return (
        <FormControl error={!!error} variant="outlined" fullWidth>
            <InputLabel id="country-select-label">Country of residence</InputLabel>
            <Select
                labelId="country-select-label"
                label="Country of residence"
                id="country-select"
                data-testid="country-select"
                onChange={handleChange}
                variant="outlined"
                value={value}
                fullWidth
            >
                {countries.map((country) => (
                    <MenuItem value={country.value} key={country.label}>
                        {country.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText data-testid="field-error">{error || " "}</FormHelperText>
        </FormControl>
    );
};

export default CountryField;
